import { LtcCostDisplay } from '@client/components/LtcCostDisplay';

interface CoverageProgressBarProps {
  coveredAmount: number;
  gapAmount: number;
  totalCost: number;
}

export function CoverageProgressBar({
  coveredAmount,
  gapAmount,
  totalCost,
}: CoverageProgressBarProps) {
  const coveragePercentage = totalCost > 0 ? (coveredAmount / totalCost) * 100 : 0;

  return (
    <div className="space-y-3">
      {/* Coverage and Gap Labels */}
      <div className="flex items-end justify-between">
        <span className="text-sm text-gray-700">
          <LtcCostDisplay value={coveredAmount} /> covered
        </span>
        <div className="flex items-baseline gap-2">
          <span className="text-accent font-sans text-3xl font-bold">
            <LtcCostDisplay value={gapAmount} />
          </span>
          <span className="text-base text-gray-700">gap</span>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="h-3 w-full overflow-hidden rounded-full bg-gray-200">
        <div
          className="bg-primary h-full rounded-full transition-all duration-500"
          style={{ width: `${Math.min(100, coveragePercentage)}%` }}
        />
      </div>
    </div>
  );
}
